'use client';

import { BlogTag } from '@/lib/blog';
import styles from './TagFilter.module.css';

interface TagFilterProps {
  tags: BlogTag[];
  selectedTag: BlogTag | null;
  onSelectTag: (tag: BlogTag | null) => void;
  allPostsLabel: string;
}

export function TagFilter({ tags, selectedTag, onSelectTag, allPostsLabel }: TagFilterProps) {
  return (
    <div className={styles.filterContainer}>
      <button
        className={`${styles.tag} ${selectedTag === null ? styles.active : ''}`}
        onClick={() => onSelectTag(null)}
      >
        <span>{allPostsLabel}</span>
      </button>
      {tags.map((tag) => (
        <button
          key={tag}
          className={`${styles.tag} ${selectedTag === tag ? styles.active : ''}`}
          onClick={() => onSelectTag(tag)}
        >
          <span>{tag}</span>
        </button>
      ))}
    </div>
  );
}

